/*
 * ******************************************************************
 * Copyright (c) 2021-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

import { Injectable } from "@angular/core";
import "@cds/core/icon/register";
// TODO: We load all available Clarity icons. Optimize if possible to import only the icons used by the UI.
// By default Clarity load Core and Essential icons. We need to explicitly import and load
// other Clarity icons + custom icons we use.
import { airplaneIcon, angleIcon, calendarIcon, ClarityIcons, cloudScaleIcon, copyToClipboardIcon, dashboardIcon, dollarBillIcon, downloadCloudIcon, downloadIcon, envelopeIcon, errorStandardIcon, eventIcon, fileSettingsIcon, infoStandardIcon, installIcon, internetOfThingsIcon, keyIcon, listIcon, lockIcon, minusCircleIcon, networkSettingsIcon, pasteIcon, popOutIcon, resourcePoolIcon, shoppingCartIcon, storageIcon, syncIcon, tasksIcon, uploadIcon, viewCardsIcon, viewListIcon, vmIcon, warningStandardIcon } from "@cds/core/icon";
import { IconDefinitions } from "@shared/services/icon/icon.defs";
import { IconShapeTuple } from "@cds/core/icon/interfaces/icon.interfaces";

@Injectable()
export class IconService {

    readonly predefinedIcons: IconShapeTuple[] = [
        cloudScaleIcon,
        airplaneIcon,
        networkSettingsIcon,
        calendarIcon,
        angleIcon,
        popOutIcon,
        lockIcon,
        infoStandardIcon,
        errorStandardIcon,
        warningStandardIcon,
        lockIcon,
        dashboardIcon,
        envelopeIcon,
        tasksIcon,
        eventIcon,
        vmIcon,
        storageIcon,
        shoppingCartIcon,
        downloadIcon,
        downloadCloudIcon,
        minusCircleIcon,
        fileSettingsIcon,
        listIcon,
        minusCircleIcon,
        dollarBillIcon,
        resourcePoolIcon,
        viewCardsIcon,
        viewListIcon,
        copyToClipboardIcon,
        pasteIcon,
        downloadIcon,
        uploadIcon,
        syncIcon,
        internetOfThingsIcon,
        keyIcon,
        installIcon
    ];
    readonly customIcons: IconShapeTuple[] = [
        ["no-recovery-region-light", IconDefinitions.noRecoveryRegionLight],
        ["no-recovery-region-dark", IconDefinitions.noRecoveryRegionDark],
        ["no-subscription-light", IconDefinitions.noSubscriptionLight],
        ["no-subscription-dark", IconDefinitions.noSubscriptionDark],
        ["success-robot-light", IconDefinitions.successRobotLight],
        ["no-service-light", IconDefinitions.noServiceLight],
        ["no-service-dark", IconDefinitions.noServiceDark],
        ["seller-vmware-light", IconDefinitions.sellerVmwareLight],
        ["seller-vmware-dark", IconDefinitions.sellerVmwareDark],
        ["seller-aws-light", IconDefinitions.sellerAwsLight],
        ["vlr", IconDefinitions.vlr],
        ["vlsr", IconDefinitions.vlsr],
        ["vlcr", IconDefinitions.vlcr],
        ["vcf", IconDefinitions.vcf],
        ["vmc", IconDefinitions.vmc],
        ["gcve", IconDefinitions.gcve],
        ["gcp", IconDefinitions.gcp],
        ["carbonblack", IconDefinitions.carbonblack],
        ["crowdstrike", IconDefinitions.crowdstrike],
        ["disaster-recovery-light", IconDefinitions.disasterRecoveryLight],
        ["site-recovery-light", IconDefinitions.siteRecoveryLight],
        ["cloud-sddc", IconDefinitions.cloudSddc],
        ["on-premises", IconDefinitions.onPremises],
        ["paired-sites", IconDefinitions.pairedSites],
        ["paired-sites-cloud", IconDefinitions.pairedSitesWithCloud],
        ["datagrid-placeholder", IconDefinitions.datagridPlaceholder],
        ["cloud-region", IconDefinitions.cloudRegion],
        ["single-on-prem", IconDefinitions.singleOnPrem],
        ["prem-to-prem", IconDefinitions.premToPrem],
        ["bidirectional-arrow", IconDefinitions.bidirectionalArrow]
    ];

    public load(): void {
        ClarityIcons.addIcons(
            ...this.predefinedIcons,
            ...this.customIcons
        );
    }
}
